// Libraries
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

// Dependencies
import { EMAIL_VERIFIED } from 'models/User';
import { useGetUserStatusQuery } from 'services/apiSlices/userApi';
import { selectors as userSelectors } from 'store/modules/user';
import { VERIFY_EMAIL } from './paths';

const PrivateRoutes = () => {
  // TODO: we are already checking this variable outside in src/containers/Routes/index.js, why do we need it here too?
  const isAuthenticated = useSelector(userSelectors.isAuthenticated);
  const { data: userStatus } = useGetUserStatusQuery(null, {
    skip: !isAuthenticated,
  });

  // if user is unauthenticated and their email is not null (legacy) but is false (unverified),
  // redirect to /verify-email to send them the verification email
  if (isAuthenticated && userStatus?.email_verified === EMAIL_VERIFIED.UNVERIFIED) {
    return <Navigate to={VERIFY_EMAIL} />;
  }

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;

/* DOCS
To be used like:

<Route exact path='/' element={<PrivateRoute />}> // this wrapper Route will protect the children Route's
  <Route exact path='/' element={<Home />} /> // Pure Route's to be rendered already protected by the parent Route
</Route>

*/
